/*****************************************************************************
 *
 * Simple HTTP API using axios to get local data files
 *
 *****************************************************************************/

import axios from 'axios';

const testing = process.env.NODE_ENV === 'test';
const apiUrl = `${testing ? 'http://localhost' : process.env.PUBLIC_URL}/data`;

/**
 * HTTP GET the provided URL
 * Returns empty array on error
 *
 * @param url
 * @returns {Promise<*>}
 */
function fetch(url) {
  return axios.get(url)
    .then(response => response.data)
    .catch(() => [])
}

/**
 * Fetch the national.json file asynchronously
 *
 * @returns {Promise<*>}
 */
function getNationalData() {
  return fetch(apiUrl + `/national.json`)
}

/**
 * Fetch the states.json file asynchronously
 *
 * @returns {Promise<*>}
 */
function getStatesData() {
  return fetch(apiUrl + `/states.json`)
}

/**
 * Fetch the corresponding county_{stateId}.json file asynchronously
 *
 * @param stateId
 * @returns {Promise<*>}
 */
function getCountyData(stateId) {
  return fetch(apiUrl + `/county_${stateId}.json`)
}

const publicApi = {
  getNationalData,
  getStatesData,
  getCountyData
}

export default publicApi
